<template>
    <div class="gallery">
        <h3 class="gallery__title | title">{{ this.$root.trans.pictureTitle }}</h3>
        <ul>
            <li
                :key="photo.identifiant"
                v-for="photo in illustrations"
            >
                <figure class="gallery__fig">
                    <img
                        :src="photo.url"
                        class="gallery__image"
                    />
                    <figcaption
                        class="gallery__caption"
                        v-html="photo.copyright"
                    />
                </figure>

            </li>
        </ul>
    </div>
</template>

<script>

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'Gallery',

    components: {
    },

    props: {
        illustrations: { type: Array, required: false },
    },

    data() {
        return {
            //
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        //
    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
        //
    },


    watch: {
        //
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {

        /* Handlers
        --------------------------------------------------------- */



    },
}
</script>
